import React from 'react';

import websitePage from 'hoc/websitePage/websitePage';
import OpenDataPage from 'components/OpenDataPage/OpenDataPage';

import SectionChannelsOverview from './patterns/SectionChannelsOverview/SectionChannelsOverview';
import SectionServiceChannels from './patterns/SectionServiceChannels/SectionServiceChannels';
import SectionChannelsItems from './patterns/SectionChannelsItems/SectionChannelsItems';

function OpenData() {
  return (
    <>
      <OpenDataPage>
        <SectionServiceChannels />
        <SectionChannelsOverview />
        <SectionChannelsItems />
      </OpenDataPage>
    </>
  );
}

export default websitePage({
  routeKey: 'OPEN_DATA',
})(OpenData);
